import React, { useEffect, useRef, useState } from 'react'
import './player-store.styles.scss';
import { useAsyncError, useLocation } from 'react-router-dom';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import StoreItemCard from './store-components/store-item-card.component';
import CartWidget from './store-components/cart-widget.component';
import StoreContributionCard from './store-components/store-contribution-card.component';
import ItemSearchBar from '@/components/SHARED/search-bar/item-search-bar.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import PlayerCollectibles from './player-collectibles.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';
import { getGameElementsFromDb } from '@/utils/getDataFromDb';
import { sortElementsNoThe } from '@/utils/sortElements';


const PlayerStore = ({ 
    gameData, 
    playerData, 
    collections,
    availableItems,
    itemType, 
    gameStats,
    teamMembers,
    saleList
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ itemsToDisplay, setItemsToDisplay ] = useState([]);
    const [ filteredItems, setFilteredItems ] = useState([]);
    const availableRef = useRef();
    const location = useLocation();

    useEffect(() => {

        return () => {
            
        }
    }, [])

    useEffect(() => {
        // console.log(itemType);
        if (!itemType || !availableItems) return;
        const filtered = Object.values(availableItems)
            .filter(i => 
                i.opt_itemType === itemType && 
                i.opt_visible === true
            );

        setItemsToDisplay(sortElementsNoThe(filtered))
        setFilteredItems(sortElementsNoThe(filtered));
    }, [itemType, availableItems]);

    // function search(text) {
    //     if (!text) {
    //         setItemsToDisplay([...availableRef.current])
    //         return;
    //     }
    //     let tempItems = [...availableRef.current]
    //     let filteredItems = tempItems
    //     .filter(i => 
    //         i.name.toLowerCase().includes(text.toLowerCase()) ||
    //         i.desc.toLowerCase().includes(text.toLowerCase())
    //     )
    //     setItemsToDisplay([...filteredItems]);
    // }

    

    return (
        <div className={`player-store ${screenSize}`}>
            <div className='left-col'>
                
                {
                    (itemsToDisplay && itemType && itemType !== 'collectible')
                    ?
                    <>
                    <ItemSearchBar 
                        allItems={filteredItems}
                        setItemsToDisplay={setItemsToDisplay} 
                        itemType={itemType}
                        collections={collections}
                        noTypes={true}
                    />
                    <div className="g-space-1"></div>
                    <div className='store-item-list'>
                        {
                            (itemsToDisplay.length > 0)
                            ?
                            itemsToDisplay
                            .map(i => (
                                <div
                                    className='card-container' 
                                    key={i.id}>
                                    {
                                        (i.opt_itemType === 'contribution')
                                        ?
                                        <StoreContributionCard 
                                            item={i} 
                                            playerData={playerData} 
                                            gameElements={availableItems}
                                            gameStats={gameStats} 
                                            teamMembers={teamMembers}
                                        />
                                        :
                                        <StoreItemCard 
                                            item={i} 
                                            playerData={playerData} 
                                            gameElements={availableItems}
                                            gameStats={gameStats} 
                                            teamMembers={teamMembers}
                                            saleList={saleList}
                                        />
                                    }
                                </div>
                            ))
                            :
                            <div className='center-col'>
                                <h4>No items for sale in this category.</h4>
                            </div>
                        }
                    </div>
                    </>
                    :
                    (itemType && itemType === 'collectible')
                    ?
                    <PlayerCollectibles
                        playerData={playerData}
                        gameStats={gameStats}
                        gameElements={availableItems}
                        teamMembers={teamMembers}
                        collections={collections}
                        itemsToDisplay={itemsToDisplay}
                        saleList={saleList}
                    />
                    :
                    <div className='center-col'>
                        <ThreeDotsLoader />
                    </div>
                }                
            </div>
            {
                (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                <div className='right-col'>
                    <div className='col-content'>
                        <section className='g-list-item current-balance'>
                            <span>Current Balance: </span>
                            <div className='balance'>
                                <ImageContainer src="/images/icons/coin.png" className='balance-coin' />
                                <span>{playerData.currency ? playerData.currency.toLocaleString() : 0}</span>
                            </div>
                        </section>
                        <div className="g-space-1"></div>
                        <div className='g-list-item'>
                            <CartWidget
                                playerData={playerData} 
                            />
                            
                        </div> 
                    </div>
                </div>
            }
        </div>
    )
}

export default PlayerStore;